import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { FormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { LiveAnnouncer } from '@angular/cdk/a11y';

@Component({
  selector: 'app-autocomplete-component',
  templateUrl: './autocomplete-component.component.html',
  styleUrls: ['./autocomplete-component.component.css']
})
export class AutocompleteComponentComponent implements OnChanges {
  @Input() items: { id: string, name: string }[] = [];
  @Input() selectName: string = '';
  @Input() allItems: { id: string, name: string }[] = [];

  separatorKeysCodes: number[] = [ENTER, COMMA];
  itemCtrl = new FormControl('');
  filteredItems: Observable<{ id: string, name: string }[]>;

  @Output() onItemsUpdated: EventEmitter<{ id: string, name: string }[]> = new EventEmitter<{ id: string, name: string }[]>();

  @ViewChild('itemInput') itemInput!: ElementRef<HTMLInputElement>;

  constructor(private announcer: LiveAnnouncer) {
    this.filteredItems = this.itemCtrl.valueChanges.pipe(
      startWith(null),
      map((value: string | null) => value ? this._filter(value) : this.allItems.slice())
    );
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['allItems']) {
      this.allItems = [...changes['allItems'].currentValue];

      this.filteredItems = this.itemCtrl.valueChanges.pipe(
        startWith(''),
        map(value => this._filter(value || ''))
      );
    }
    if (changes['items']) {
      this.items = [...changes['items'].currentValue];

      if (this.items.length > 0) {
        this.onItemsUpdated.emit(this.items);
      }
    }
  }

  add(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();

    if (value) {
      const selectedItem = this.allItems.find(item => item.name === value);
      if (selectedItem && !this.items.find(item => item.id === selectedItem.id)) {
        this.items.push(selectedItem);
      }
    }

    event.chipInput!.clear();
    this.itemCtrl.setValue(null);
  }

  remove(item: { id: string, name: string }): void {
    const index = this.items.findIndex(selectedItem => selectedItem.id === item.id);

    if (index >= 0) {
      this.items.splice(index, 1);
      this.announcer.announce(`Removed ${item.name}`);
    }

    this.onItemsUpdated.emit(this.items);
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    const selectedItem = this.allItems.find(item => item.id === event.option.value);
    if (selectedItem && !this.items.find(item => item.id === selectedItem.id)) {
      this.items.push(selectedItem);
    }
    this.itemInput.nativeElement.value = '';
    this.itemCtrl.setValue(null);

    this.onItemsUpdated.emit(this.items);
  }

  private _filter(value: string): { id: string, name: string }[] {
    const filterValue = value.toLowerCase();

    return this.allItems.filter(item => item.id.toLowerCase().includes(filterValue));
  }
}
